import React, { useEffect } from 'react';
import { META_PIXEL_ID } from '../lib/config';

/**
 * Espacio reservado para el pixel de Meta.
 * Solo se inyecta cuando META_PIXEL_ID tiene un valor real en lib/config.ts.
 */
export function MetaPixel() {
  useEffect(() => {
    if (!META_PIXEL_ID) return;
    if (document.getElementById('meta-pixel-script')) return;
    const script = document.createElement('script');
    script.id = 'meta-pixel-script';
    script.async = true;
    script.innerHTML = `
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
      n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
      document,'script','https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${META_PIXEL_ID}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
  }, []);
  return null;
}